import * as R from 'ramda'
import moment from 'moment'
import { parsePeriod } from 'utils/stuff'

export default (properties, listings, period) => {
	let parsedPeriod = period == 'projected' ? parsePeriod('YTM'): parsePeriod(period)

	let totalCount = 0
	let filteredListings = R.values(R.filter(x => (moment(parsedPeriod.from) < moment(x.dateTill) < moment(parsedPeriod.to)))(listings))
	let listingsByPropertyID = R.pipe(
		R.values
	  , R.groupBy(R.prop('propertyID'))
	)(filteredListings)

	let res = R.map(property => {
		let propertyListings = listingsByPropertyID[property._id]
		if(!propertyListings) return 'N/A'
		totalCount++
		return R.pipe(R.reduce((acc, next) => acc + moment(next.dateTill).diff(moment(next.dateFrom), 'days'), 0), (acc) => acc / propertyListings.length)(propertyListings)
	})(properties)
	res.total = R.pipe(R.reduce((acc, next) => acc + moment(next.dateTill).diff(moment(next.dateFrom), 'days'), 0), (acc) => acc / filteredListings.length)(filteredListings)
	return res
}



// WEBPACK FOOTER //
// ./src/helpers/kpi/daysForRent.js